import { render, staticRenderFns } from "./RFCardManage.vue?vue&type=template&id=6e3f2d8c&scoped=true&"
import script from "./RFCardManage.vue?vue&type=script&lang=js&"
export * from "./RFCardManage.vue?vue&type=script&lang=js&"
import style0 from "./RFCardManage.vue?vue&type=style&index=0&id=6e3f2d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3f2d8c",
  null
  
)

export default component.exports